// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-atlas-page-tsx": () => import("./../../../src/templates/atlas-page.tsx" /* webpackChunkName: "component---src-templates-atlas-page-tsx" */),
  "component---src-templates-portal-page-tsx": () => import("./../../../src/templates/portal-page.tsx" /* webpackChunkName: "component---src-templates-portal-page-tsx" */),
  "component---src-templates-redirect-page-tsx": () => import("./../../../src/templates/redirect-page.tsx" /* webpackChunkName: "component---src-templates-redirect-page-tsx" */)
}

